import React, { PureComponent } from "react"
import throttle from "lodash/throttle";
import TextField from '@material-ui/core/TextField';


class ArticleCustomUrl extends PureComponent {
  constructor(props) {
    super(props);
    this.setChangeValue = throttle(this._setChangeValue, 100);
    this.textArea = React.createRef();
    this.state = { length: 0, urlString: props.urlString || "" };
  }

  componentDidMount() {
    const { defaultValue } = this.props;
    let length = 0;
    if (defaultValue) {
      length = defaultValue.length;
    }
    this.setState({ length });
  }
  _setChangeValue = (e) => {
    this.props.setUrlString(e.target.value, e.type);
  }
  onChange = (e) => {
    e.persist();
    this.setState({ length: e.target.value.length, urlString: e.target.value });
    this.setChangeValue(e);
  }
  render() {
    const { urlString } = this.state;

    return (
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <TextField
          id="standard-name"
          label="Custom Url String"
          value={urlString}
          onChange={this.onChange}
          onBlur={this.onChange}
          InputProps={{
            style: {
              border:"1px solid #ced3dc",
              width: "93%",
            }
          }}
          inputProps={{ maxLength: 300 }}
          multiline={true}
          fullWidth
          margin="normal"
        /><p>{`${urlString && urlString.length || 0}/100`}</p>
      </div>
    )
  }
}

export default ArticleCustomUrl;
